import { render, staticRenderFns } from "./TransactionRecordInfo.vue?vue&type=template&id=5336214a&scoped=true"
import script from "./TransactionRecordInfo.vue?vue&type=script&lang=js"
export * from "./TransactionRecordInfo.vue?vue&type=script&lang=js"
import style0 from "./TransactionRecordInfo.vue?vue&type=style&index=0&id=5336214a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5336214a",
  null
  
)

export default component.exports